import AbstractApiRequest from '@/api/apimodel/abstract-api-request'

export default class putCredit3DSecurity extends AbstractApiRequest {
  // 取引ID
  accessId = ''
  // 取引パスワード
  accessPass = ''
}
